module.exports = __webpack_public_path__ + "img/fmdiefaimg.8daa8212.jpg";